import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-696d3085"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "right-menu" }
const _hoisted_3 = { class: "avatar-wrapper" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  xmlns: "http://www.w3.org/2000/svg",
  style: {"width":"15px","margin-left":"10px"},
  viewBox: "0 0 1024 1024",
  "data-v-394d1fd8": ""
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"block"} }, " 退出登录 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Hamburger = _resolveComponent("Hamburger")!
  const _component_Screenfull = _resolveComponent("Screenfull")!
  const _component_LangSelect = _resolveComponent("LangSelect")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Hamburger, {
      id: "hamburger-container",
      "is-active": $setup.sidebar.opened,
      class: "hamburger-container",
      onToggleClick: _ctx.toggleSideBar
    }, null, 8, ["is-active", "onToggleClick"]),
    _createElementVNode("div", _hoisted_2, [
      ($setup.device !== 'mobile')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            false
              ? (_openBlock(), _createBlock(_component_Screenfull, {
                  key: 0,
                  class: "right-menu-item hover-effect"
                }))
              : _createCommentVNode("", true),
            false
              ? (_openBlock(), _createBlock(_component_LangSelect, {
                  key: 1,
                  class: "right-menu-item hover-effect"
                }))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_el_dropdown, {
        class: "dropdown avatar-container right-menu-item hover-effect",
        trigger: "click"
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.version), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, {
                divided: "",
                onClick: $setup.revisePwd
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 修改密码 ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_dropdown_item, {
                divided: "",
                onClick: _ctx.logout
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _ctx.userIcon,
              class: "user-avatar"
            }, null, 8, _hoisted_4),
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.manager) + " ", 1),
              (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}